import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { AllSiteSummaryFilterObject, useSiteSummaryListingStore } from '@store/siteSummaryListingFilterStore';
import { formatDateDDMMYY, isFilterValuePresent, RoleType } from '@helper/utils';
import { RightTabCount } from '@components/common/count/RightTabCount';
import { useUserRoleType } from '@hooks/useUserRoleType';

export const SiteSummaryFilterTag = (props: { count: number }): ReactElement => {
	const { count } = props;
	const { allSiteSummaryFilter, updateFilter, resetSiteSummaryFilter } = useSiteSummaryListingStore();
	const userRole = useUserRoleType();

	const renderFilterValue = (key: string, value: keyof AllSiteSummaryFilterObject): string => {
		if (key === 'lastactivitydate') {
			if (Array.isArray(value) && value.length === 2 && value[0] instanceof Date && value[1] instanceof Date) {
				const startDate = value[0];
				const endDate = value[1];
				return `${formatDateDDMMYY(startDate)} - ${formatDateDDMMYY(endDate)}`;
			}
		}
		if (key === 'createddate') {
			if (Array.isArray(value) && value.length === 2 && value[0] instanceof Date && value[1] instanceof Date) {
				const startDate = value[0];
				const endDate = value[1];
				return `${formatDateDDMMYY(startDate)} - ${formatDateDDMMYY(endDate)}`;
			}
		}
		if (key === 'competition_site') {
			return `Competition Site`;
		}
		if (key === 'adopted_site') {
			return `Adopted Site`;
		}
		if (key === 'lost_site') {
			return `Lost Site`;
		}
		if (key === 'ssm_site') {
			return `SMM`;
		}
		return String(value);
	};
	const handleCross = (
		e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
		key: string,
		filterData: AllSiteSummaryFilterObject
	): void => {
		e.preventDefault();
		let defaultValue;
		if (key === 'lastactivitydate') {
			defaultValue = [null, null];
		}
		if (key === 'lost_site') {
			updateFilter({
				...filterData,
				lost_site: false,
				current_stage_of_site_c: '',
			});
			return;
		}
		if (key === 'ssm_site') {
			updateFilter({
				...filterData,
				ssm_site: false,
			});
			return;
		}
		if (!defaultValue) {
			defaultValue = '';
		}
		updateFilter({
			...filterData,
			[key]: defaultValue,
		});
	};

	const shouldShowCurrentStage = !(
		allSiteSummaryFilter.current_stage_of_site_c === 'Rejected' && allSiteSummaryFilter.lost_site === true
	);

	if (
		userRole !== RoleType.RBDM &&
		(!allSiteSummaryFilter || !Object.values(allSiteSummaryFilter).some(isFilterValuePresent))
	)
		return <></>;

	return (
		<div className="filter-tags">
			<ul className="tag-list">
				{Object.entries(allSiteSummaryFilter).map(([key, value]) => {
					if (key === 'current_stage_of_site_c' && !shouldShowCurrentStage) {
						return null;
					}
					if (isFilterValuePresent(value)) {
						return (
							<li key={key}>
								{`${renderFilterValue(key, value)}`}
								<NavLink
									to="#"
									aria-label="disable tag"
									onClick={(e) => {
										handleCross(e, key, allSiteSummaryFilter);
									}}
								>
									<span className="icon-cross"></span>
								</NavLink>
							</li>
						);
					}
				})}
				{Object.values(allSiteSummaryFilter).some(isFilterValuePresent) && (
					<NavLink to="#" aria-label="Clear All" className="clear-all-btn" onClick={resetSiteSummaryFilter}>
						Clear All
					</NavLink>
				)}
			</ul>
			<RightTabCount count={count} />
		</div>
	);
};
